require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-v-ysmf.json") })
        }
      }, "path---photos-professional-v-ysmf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-v-ysmf!./.cache/json/photos-professional-v-ysmf.json
// module id = 930
// module chunks = 231608221292675